import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
    path: '/',
    meta: {
      title: '首页'
    },
    component: (resolve) => require(['../views/index.vue'], resolve),
  }, ]
})



// WEBPACK FOOTER //
// ./src/router/index.js